import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    data: [],
    typeTests: [],
    tests: null,
    testsForCourse: null,
    loading: false,
    course_template_tests: {},
    duplicateTestCreateCourse: {}
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    const newData = [...state.data];

    switch (type) {
        case actions.COURSES_FETCHED:
            return { ...state, data: payload };

        // eslint-disable-next-line no-case-declarations
        case actions.COURSE_FETCHED:
            const theCourse = newData.find(c => c.id === payload.id);
            if (theCourse) {
                Object.assign(theCourse, payload);
            } else {
                newData.push(payload);
            }
            return { ...state, data: newData };

        case actions.UPDATE_COURSE:
            newData[newData.findIndex(c => c.courseId === payload.courseId)] =
                payload.value;
            return { ...state, data: newData };

        case actions.COURSE_CREATED:
            newData.push(payload);
            return { ...state, data: newData };

        case actions.COURSE_DELETED:
            return {
                ...state,
                data: newData.filter(c => c.courseId !== payload.courseId),
            };

        case actions.COURSES_FETCH_LOADING:
            return { ...state, ...payload };

        case actions.FETCH_TYPE_TESTS:
            return { ...state, typeTests: payload };

        case actions.FETCH_TESTS_BY_TYPE:
            return { ...state, tests: payload };

        case actions.CHANGE_COURSE_TEMPLATE_TESTS:
            return { ...state, course_template_tests: payload };

        case actions.FETCH_TESTS_BY_COURSE:
            return { ...state, testsForCourse: payload };

        case actions.SET_SELECT_TESTS_CREATE_COURSE:
            return { ...state, duplicateTestCreateCourse: payload };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/courses/courses.reducer.js